'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../shared-components.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  @import url(\"https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700\");\n  @import url(\"https://fonts.googleapis.com/css?family=Merriweather:400,700\");\n  @import url(\"https://fonts.googleapis.com/css?family=Damion:400\");\n\n  html,body {\n    font-family: Source Sans Pro, sans-serif;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  p {\n    margin: 0 0 15px;\n  }\n\n  *:active {\n    outline: none;\n  }\n\n  ", "\n"], ["\n  @import url(\"https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700\");\n  @import url(\"https://fonts.googleapis.com/css?family=Merriweather:400,700\");\n  @import url(\"https://fonts.googleapis.com/css?family=Damion:400\");\n\n  html,body {\n    font-family: Source Sans Pro, sans-serif;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  p {\n    margin: 0 0 15px;\n  }\n\n  *:active {\n    outline: none;\n  }\n\n  ", "\n"]);
// import "@fortawesome/fontawesome-pro/css/all.min.css"

var global = styled.createGlobalStyle(_templateObject, function (props) {
  return props.customGlobal && props.customGlobal;
});

module.exports = global;
//# sourceMappingURL=global.js.map
